// @flow
import { fetchServerData } from './utils';

/**
 * Notifica o paciente por FCM (Django send_chat_notification) após o terapeuta enviar mensagem ao RTDB.
 * Fire-and-forget: falhas não bloqueiam o envio da mensagem.
 */
export const notifyPatientNewChatMessage = (chatId: string): void => {
  if (!chatId) {
    return;
  }
  // Barra final obrigatória (Django APPEND_SLASH + POST não redireciona com body).
  fetchServerData(['notifications', 'chat/'], { chat_id: chatId }, 'POST').catch(err => {
    console.warn('[ChatNotificationServer] notifyPatientNewChatMessage failed', err);
  });
};
